// TODO PP-16776: move LoggedInWeb/helpers/floatmath here once we complete webpack LoggedInWeb migration

export * from '../../LoggedInWeb/helpers/floatmath';

export function floor(num: number, precision: number): number {
	return Math.floor(+(num + 'e' + precision)) / +('1e' + precision);
}
